module.exports = __webpack_public_path__ + "img/main_sub_card_edu.a75937b1.png";